/**
 * @generated SignedSource<<473228e85a57050190128cd8a22ee652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleMemberLiveChatPayload",
    "kind": "LinkedField",
    "name": "toggleMemberLiveChat",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Member",
        "kind": "LinkedField",
        "name": "member",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalProfile",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MemberProfile",
            "kind": "LinkedField",
            "name": "inboxProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profilePicUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "liveChat",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationHistoryQuery_toggleMemberLiveChatMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConversationHistoryQuery_toggleMemberLiveChatMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaa74a822d65aa39d282ff0c06a9a513",
    "id": null,
    "metadata": {},
    "name": "ConversationHistoryQuery_toggleMemberLiveChatMutation",
    "operationKind": "mutation",
    "text": "mutation ConversationHistoryQuery_toggleMemberLiveChatMutation(\n  $input: ToggleMemberLiveChatInput!\n) {\n  toggleMemberLiveChat(input: $input) {\n    clientMutationId\n    error {\n      message\n      code\n    }\n    member {\n      id\n      externalId\n      externalProfile\n      inboxProfile {\n        firstName\n        lastName\n        profilePicUrl\n      }\n      liveChat\n    }\n  }\n}\n"
  }
};
})();

node.hash = "61b691f98ad924eb44fff6ba02bb386a";

module.exports = node;
